import {
    IonPage, IonContent, IonInput, IonAlert
} from '@ionic/react';
import React, {Component} from "react";
import './css/style.css';
import {withRouter} from "react-router-dom";
import Script from "react-load-script";
import {captchaKeFuAppId, captchaUrl, jumpKeFu} from "../../../../utils/common";
import {
    bindPhone,
    unBindPhoneFaceVerify,
    unBindPhoneFaceVerifyQuery,
    bindPhoneQuery,
    sendSmsCodeByToken,
    changePhone, getUserInfo
} from "./Service";
import {PlatMd5} from "../../../../utils/platMd5";
import cookieUtil from "../../../../utils/cookieUtil";
import {getQueryVariable} from "../../../../utils/commonFunction";
import {getTokenParam} from "../../Service";


class PhoneBind extends Component {

    constructor(props) {
        super(props);
        this.state = {
            phone: '',
            phoneTip: 0,
            code: '',
            codeTip: null,
            agreementTip: true,
            scriptLoaded: false,
            showTipModal: false,
            getCodeMsg: "获取验证码",
            getCodeMsgTwo: "获取验证码",
            showNoticeTip: false,
            djs: '',
            showGreyBackGround: false,
            accounts: '',
            token: null,
            stepTip: 1,
            bindPhone: '',
            bindTime: '',
            insurePwd: '',
            isFaceVerfyBox: false,
            faceVerifyUrl: '',
            faceVerifyPm: '',
            currpage: 0,
            isAgree: false,
            isH5: true,
            remainCount: 5,
            certifyState: '',
            changeType: '',
            unBindSmsCode: '',
        }
    }

    regPhone = new RegExp(/^[1][3,4,5,6,7,8,9][0-9]{9}$/)
    regCode = new RegExp(/^[0-9]{6}$/)

    setPhone = (e) => {
        this.setState({phone: e, phoneTip: 0})
    }
    checkPhone = () => {
        const {phone} = this.state;
        let phoneTip = 0;
        if (!this.regPhone.test(phone)) {
            phoneTip = 1;
        }
        console.log('phoneTip====' + phoneTip)
        this.setState({
            phoneTip: phoneTip,
        })
    };
    /**
     * 关闭弹框控制
     */
    closeTipBox = () => {
        this.setState({
            isShowTip: false,
            showTipMsg: null
        })
    }
    setCode = (e) => {
        let codeTip = 0;
        if (this.regCode.test(e)) {
            codeTip = 1
        }
        this.setState({
            code: e,
            codeTip: codeTip
        })
    }
    showNotice = () => {
        const {showNoticeTip} = this.state;
        this.setState({
            showNoticeTip: !showNoticeTip
        })
    }

    componentDidMount() {
        let pms = getQueryVariable('pm');
        if (pms != null) {
            this.setState({isFaceVerfy: true})
            let params = {}
            getTokenParam(params, '?pagePm=' + pms).then(ret => {
                if (ret.code === '10000') {
                    this.setState({token: ret.data.accessToken, changeType: 2});
                    this.queryUserInfo(ret.data.accessToken);
                    this.faceVerifySearch(ret.data.accessToken);
                }
            })
        }
        if (cookieUtil.has("access_token")) {
            console.log("phoneBind1=" + cookieUtil.get("access_token"));
            this.setState({token: cookieUtil.get("access_token")})
            this.queryBindPhone();
        }
        if (cookieUtil.has("userInfo")) {
            let userInfoJson = cookieUtil.get("userInfo") != 'undefined' ? JSON.parse(cookieUtil.get("userInfo")) : '';
            console.log(userInfoJson);
            this.setState({accounts: userInfoJson.accounts})
        }
    }

    queryUserInfo = (token) => {
        if (token != undefined && token != '') {
            let param = {
                "access_token": token
            }
            getUserInfo(param).then(res => {
                if (res.code === '10000') {
                    cookieUtil.put("access_token", token);
                    cookieUtil.putExpire("userInfo", JSON.stringify(res.data))
                }
            }).catch(err => {
                console.log(err);
            });
        }
    }
    /**
     * 人脸识别状态查询
     * @param pm
     */
    faceVerifySearch = (pm) => {
        if (pm !== '') {
            let round = 1;
            const _that = this;
            let myVal = setInterval(function () {
                const parms = {
                    'access_token': pm,
                }
                unBindPhoneFaceVerifyQuery(parms, false).then(ret => {
                    if (ret.code === '10000') {
                        clearInterval(myVal);
                        _that.setState({
                            stepTip: 7,
                            sysId: ret.data.recordId,
                            isFaceVerfy: false,
                            idCard: '',
                            changeType: 2
                        })
                    }
                }).catch(err => {
                    console.log(err);
                });
                if (round > 5) {
                    clearInterval(myVal);
                    unBindPhoneFaceVerifyQuery(parms, false).then(ret => {
                        if (ret.code === '10000') {
                            clearInterval(myVal);
                            _that.setState({
                                stepTip: 7,
                                sysId: ret.data.recordId,
                                isFaceVerfy: false,
                                idCard: '',
                                remainCount: ret.data.remainCount,
                                certifyState: ret.data.certifyState,
                            })
                        } else {
                            _that.setState({
                                isFaceVerfy: false,
                                isShowTip: true,
                                showTipMsg: ret.msg
                            })
                        }
                    }).catch(err => {
                        console.log(err);
                    });
                }
                round++;
            }, 2000);
        }
    }
    queryBindPhone = () => {
        const {token} = this.state;
        if (cookieUtil.has('access_token')) {
            console.log("phoneBind2=" + cookieUtil.get("access_token"));
            const params = {
                'access_token': cookieUtil.get('access_token'),
            };
            bindPhoneQuery(params).then(ret => {
                console.log(ret);
                if (ret.code === '10000') {
                    if (ret.data.flag === 1) {
                        this.setState({
                            bindPhone: ret.data.phone,
                            bindTime: ret.data.bindTime,
                            stepTip: 2,
                            showGreyBackGround: true,
                            insurePwd: '',
                        })
                    }
                } else {
                    this.setState({
                        isShowTip: true,
                        showTipMsg: ret.msg
                    })
                }
            }).catch(err => {
            });
        }
    }
    submitBindPhone = () => {
        const _that = this;
        const {phone, code, insurePwd, token} = this.state;
        if (insurePwd === '') {
            _that.setState({
                isShowTip: true,
                showTipMsg: '请输入正确的保险箱密码'
            })
        }
        const params = {
            'phone': phone,
            'smsCode': code,
            'insurePwd': PlatMd5.hashStr(insurePwd).toUpperCase(),
            'access_token': token
        }
        console.log(params)
        bindPhone(params).then(ret => {
            if (ret.code === '10000') {
                console.log(ret.data);
                _that.setState({
                    isShowTip: true,
                    showTipMsg: "绑定成功",
                    insurePwd: '',
                })
                this.queryBindPhone();
            } else {
                _that.setState({
                    isShowTip: true,
                    showTipMsg: ret.msg
                })
            }
        }).catch(err => {
            console.log(err);
        });
    }
    bindPhoneSendMsg = () => {
        const _that = this;
        const {phone, phoneTip, accounts, token, getCodeMsg, bindPhone} = this.state;
        if ("获取验证码" !== getCodeMsg) {
            return;
        }
        /*if (bindPhone === phone) {
            _that.setState({
                isShowTip: true,
                showTipMsg: '手机已绑定，无需操作换绑哦！'
            })
        }*/
        if (phone === '' || phoneTip === 1) {
            _that.setState({
                isShowTip: true,
                showTipMsg: "请输入正确的手机号"
            })
        } else {
            // eslint-disable-next-line
            let captcha1 = new TencentCaptcha(captchaKeFuAppId(), function (res) {
                if (res.ret === 0) {
                    const urlParms = {
                        'accounts': accounts,
                        'phone': phone,
                        'ticket': res.ticket,
                        'randStr': res.randstr,
                        'sType': '0',
                        'access_token': token,
                    }
                    sendSmsCodeByToken(urlParms).then(ret => {
                        if (ret.code === '10000') {
                            captcha1.destroy();
                            // alert("验证码已发送，请注意查收")
                            _that.setState({
                                isShowTip: true,
                                showTipMsg: "验证码已发送，请注意查收"
                            })
                            let djs = 60;
                            let aa = '';
                            let timeout = setInterval(function () {
                                djs--;
                                aa = (djs === 0) ? '获取验证码' : (djs + 's');
                                if (djs === 0 || djs < 0) {
                                    clearInterval(timeout);
                                }
                                _that.setState({djs: djs, getCodeMsg: aa})
                            }, 999)
                        } else {
                            //alert(ret.msg);
                            _that.setState({
                                isShowTip: true,
                                showTipMsg: ret.msg
                            })
                            captcha1.destroy();
                        }
                    }).catch(err => {
                        console.log(err);
                        captcha1.destroy();
                    });
                }
            }, {bizState: 'RSCNO7XFNGG9r6xB'});
            // 显示验证码
            captcha1.show();
        }
    }
    unBindPhoneSendMsg = () => {
        const _that = this;
        const {token, getCodeMsgTwo, insurePwd} = this.state;
        if ("获取验证码" !== getCodeMsgTwo) {
            return;
        }
        if (insurePwd === '') {
            this.setState({
                isShowTip: true,
                showTipMsg: "请输入正确的保险箱密码"
            })
            return;
        }
        // eslint-disable-next-line
        let captcha1 = new TencentCaptcha(captchaKeFuAppId(), function (res) {
            if (res.ret === 0) {
                const urlParms = {
                    'access_token': token,
                    'ticket': res.ticket,
                    'randStr': res.randstr,
                    'sType': '5'
                }
                sendSmsCodeByToken(urlParms).then(ret => {
                    if (ret.code === '10000') {
                        captcha1.destroy();
                        _that.setState({
                            isShowTip: true,
                            showTipMsg: "验证码已发送，请注意查收"
                        })
                        let djs = 60;
                        let aa = '';
                        let timeout = setInterval(function () {
                            djs--;
                            aa = (djs === 0) ? '获取验证码' : (djs + 's');
                            if (djs === 0 || djs < 0) {
                                clearInterval(timeout);
                            }
                            _that.setState({djs: djs, getCodeMsgTwo: aa})
                        }, 999)
                    } else {
                        _that.setState({
                            isShowTip: true,
                            showTipMsg: ret.msg
                        })
                        captcha1.destroy();
                    }
                }).catch(err => {
                    console.log(err);
                    captcha1.destroy();
                });
            }
        }, {bizState: 'RSCNO7XFNGG9r6xB'});
        captcha1.show(); // 显示验证码

    }
    unBindPhoneFaceVerify = () => {
        const {token, insurePwd, isAgree} = this.state;
        if (!isAgree) {
            this.setState({
                isShowTip: true,
                showTipMsg: "请仔细阅读并同意《人脸识别服务协议》《个人信息共享授权书》。"
            })
            return;
        }
        if (insurePwd === '') {
            this.setState({
                isShowTip: true,
                showTipMsg: "请输入正确的保险箱密码"
            })
            return;
        }
        console.log(insurePwd)
        const urlParms = {
            'access_token': token,
            'boxPwd': PlatMd5.hashStr(insurePwd).toUpperCase(),
        }
        unBindPhoneFaceVerify(urlParms).then(ret => {
            console.log(ret)
            if (ret.code === '10000') {
                if (ret.data.certifyUrl) {
                    window.location.href = ret.data.certifyUrl;
                }
                // this.setState({
                //     stepTip: 6,
                //     remainCount: ret.data.remainCount -1,
                // })
            } else {
                this.setState({
                    isShowTip: true,
                    showTipMsg: ret.msg
                })
            }
        }).catch(err => {
            console.log(err);
        });
    }
    submitUnBindPhone = () => {
        const {phone, unBindSmsCode, insurePwd, token} = this.state;
        if (insurePwd === '') {
            this.setState({
                isShowTip: true,
                showTipMsg: "请输入正确的保险箱密码"
            })
            return;
        }
        if (!this.regCode.test(unBindSmsCode)) {
            this.setState({
                isShowTip: true,
                showTipMsg: "请输入正确的验证码"
            })
            return;
        }
        this.setState({
            stepTip: 5,
        })
    }
    submitChangePhone = () => {
        const _that = this;
        const {changeType, phone, unBindSmsCode, code, insurePwd, token} = this.state;
        if (changeType == '') {
            _that.setState({
                isShowTip: true,
                showTipMsg: '请选择换绑方式'
            })
        }
        if (insurePwd == '') {
            _that.setState({
                isShowTip: true,
                showTipMsg: '请输入正确的保险箱密码'
            })
        }
        /*if (bindPhone === phone) {
            _that.setState({
                isShowTip: true,
                showTipMsg: '请输入正确的保险箱密码'
            })
        }*/
        if (!this.regCode.test(code)) {
            _that.setState({
                isShowTip: true,
                showTipMsg: '请输入正确的验证码'
            })
        }
        const params = {
            'changeType': changeType,
            'phone': phone,
            'bindSmsCode': code,
            'unBindSmsCode': changeType === 1 ? unBindSmsCode : '',
            'insurePwd': PlatMd5.hashStr(insurePwd).toUpperCase(),
            'access_token': token
        }
        console.log(params)
        changePhone(params).then(ret => {
            if (ret.code === '10000') {
                console.log(ret.data);
                _that.setState({
                    isShowTip: true,
                    showTipMsg: "换绑成功",
                    insurePwd: '',
                })
                this.queryBindPhone();
            } else {
                _that.setState({
                    isShowTip: true,
                    showTipMsg: ret.msg
                })
            }
        }).catch(err => {
            console.log(err);
        });
    }

    render() {
        const {
            phone,
            phoneTip,
            showNoticeTip,
            getCodeMsg,
            getCodeMsgTwo,
            showGreyBackGround,
            stepTip,
            bindPhone,
            bindTime,
            insurePwd,
            isAgree,
            remainCount
        } = this.state;

        return (
            <IonPage>
                <IonContent fullscreen>
                    {!this.state.isFaceVerfy &&
                        <div className="sut_cont bggray">
                            <div className={phoneTip === 1 ? "phone_top pr mb56" : "phone_top pr"}>
                                <div className="top_title">绑定手机</div>
                            </div>
                            <div className="cont_kf">
                                <div className={stepTip === 1 ? "phone_input_box pr" : "dn"}>
                                    <div className={phoneTip === 1 ? "point pa" : "point pa dn"}><p>手机号格式错误</p>
                                    </div>
                                    <div className="border-bottom"></div>
                                    <div className="phone_identity clearfix">
                                        <span className="w168">手机号</span>
                                        <IonInput type="text" className="ipt input-tex4"
                                                  maxlength={11} minlength={11} value={phone}
                                                  onIonChange={e => this.setPhone(e.target.value)}
                                                  onIonBlur={e => this.checkPhone()}
                                                  placeholder="请输入11位手机号码"/>
                                    </div>
                                    <Script
                                        url={captchaUrl()}
                                        onError={this.handleScriptError}
                                        onLoad={this.handleScriptLoad}
                                    />

                                    <div className="phone_identity clearfix">
                                        <span className="w168">验证码</span>
                                        <IonInput type="text" className="input-tex2" maxlength={6} minlength={4}
                                                  onIonChange={e => this.setCode(e.target.value)}
                                                  placeholder="请输入短信验证码"/>
                                        <input type="button" onClick={() => this.bindPhoneSendMsg()}
                                               className="input-button-kefu"
                                               value={getCodeMsg}/>
                                    </div>
                                    <div className="phone_identity clearfix">
                                        <span className="w168">保险箱密码</span>
                                        <IonInput type="password" className="ipt input-tex4"
                                                  value={insurePwd}
                                                  onIonChange={e => this.setState({insurePwd: e.target.value})}
                                                  placeholder="请输入保险箱密码"/>
                                    </div>
                                    <a className="btn_kf mt100" onClick={this.submitBindPhone}>确定</a>
                                </div>
                                <div className={stepTip === 1 ? "cont_tex" : "dn"}>
                                    <div className="cont_tex_title" onClick={this.showNotice}>注意事项</div>
                                    <p className={showNoticeTip ? "hidden_tex" : "dn"}>1.账号绑定微信等之前需要进行手机绑定<br/>
                                        2.绑定手机3日之后才可以绑定微信等<br/>
                                        3.可通过已绑定手机号码自助找密、解绑本机等</p>
                                </div>

                                {/*<!-------------------------灰色透明层--------------------->*/}
                                <div className={showGreyBackGround ? "greybackground dn" : "dn"}></div>
                                {/*<!-------------------------绑定手机 tc--------------------->*/}
                                <div className={stepTip === 2 ? "tc02" : "dn"}>
                                    <div className="tc_bg">
                                        {/*<a className="close"*/}
                                        {/*   onClick={() => this.setState({stepTip: 1, showGreyBackGround: false})}>关闭</a>*/}
                                        <div className="tc_cont pr">
                                            <div className="tc_title">绑定手机</div>
                                            <div className="tc_cont_bdsj">
                                                <p>用户绑定手机号信息</p>
                                                <p className="textGrey9">{bindPhone}</p>
                                                <p>绑定手机时间</p>
                                                <p className="textGrey9">{bindTime}</p>
                                                <a className="btn_kf m50"
                                                   onClick={() => this.setState({stepTip: 3})}>点击换绑</a>
                                                <p className="textGrey9 pb10">换绑中途退出,则换绑失败,原绑定手机不予解除</p>
                                                <p className="textGrey9">如有疑问请<a
                                                    onClick={() => jumpKeFu(this.state.token)}
                                                    className="textBlue">联系客服</a></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/*<!-------------------------选择换绑的方式 tc--------------------->*/}
                                <div className={stepTip === 3 ? "tc02" : "dn"}>
                                    <div className="tc_bg">
                                        <a className="close"
                                           onClick={() => this.setState({
                                               stepTip: 2,
                                               showGreyBackGround: false
                                           })}>关闭</a>
                                        <div className="tc_cont pr">
                                            <div className="tc_title">选择换绑方式</div>
                                            <a className="btn_kf m50"
                                               onClick={() => this.setState({stepTip: 4, changeType: 1})}>验证码验证</a>
                                            <a className="btn02"
                                               onClick={() => this.setState({
                                                   stepTip: 6,
                                                   changeType: 2
                                               })}>人脸识别验证</a>
                                            <div className="tc_cont_bdsj">
                                                <p className="textGrey9 pb10">换绑中途退出,则换绑失败,原绑定手机不予解除</p>
                                                <p className="textGrey9 pb30">如有疑问请<a
                                                    className="textBlue">联系客服</a>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/*<!-------------------------验证码验证方式绑定tc01--------------------->*/}
                                <div className={stepTip === 4 ? "tc02" : "dn"}>
                                    <div className="tc_bg">
                                        <a className="close" onClick={() => this.setState({stepTip: 3})}>关闭</a>
                                        <div className="tc_cont pr">
                                            <div className="tc_title">验证码验证</div>
                                            <div className="point2 pa dn"><p>短信验证码不匹配</p></div>
                                            <div className="tc_cont_tex">
                                                <div className="tc_input clearfix">
                                                    <span>保险箱密码</span>
                                                    <input type="password" className="input-tex2"
                                                           placeholder="请输入保险箱密码" value={insurePwd}
                                                           onChange={e => this.setState({insurePwd: e.target.value})}/>
                                                </div>
                                                <p>原手机号<em>{bindPhone}</em></p>
                                                <div className="tc_input clearfix">
                                                    <span>验证码</span>
                                                    <input type="text" className="input-tex2"
                                                           onChange={e => this.setState({unBindSmsCode: e.target.value})}
                                                           placeholder="请输入验证码"/>
                                                    <input type="button" className="input-button-kefu"
                                                           onClick={() => this.unBindPhoneSendMsg()}
                                                           value={getCodeMsgTwo}/>
                                                </div>
                                                <a className="btn_kf m50"
                                                   onClick={() => this.submitUnBindPhone()}>下一步</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/*<!-------------------------验证码验证方式绑定tc02--------------------->*/}
                                <div className={stepTip === 5 ? "tc02" : "dn"}>
                                    <div className="tc_bg">
                                        <a className="close" onClick={() => this.setState({stepTip: 3})}>关闭</a>
                                        <div className="tc_cont pr">
                                            <div className="tc_title">验证码验证</div>
                                            {/*<div className="point2 pa"><p>短信验证码不匹配</p></div>*/}
                                            <div className="tc_cont_tex">
                                                <div className="tc_input clearfix">
                                                    <span>手机号</span>
                                                    <input type="text" className="input-tex2"
                                                           onChange={e => this.setState({phone: e.target.value})}
                                                           placeholder="请输入手机号码"/>
                                                </div>
                                                <div className="tc_input clearfix">
                                                    <span>验证码</span>
                                                    <input type="text" className="input-tex2"
                                                           onChange={e => this.setCode(e.target.value)}
                                                           placeholder="请输入验证码"/>
                                                    <input type="button" className="input-button-kefu"
                                                           onClick={() => this.bindPhoneSendMsg()} value={getCodeMsg}/>
                                                </div>
                                                <a className="btn_kf m50" onClick={this.submitChangePhone}>确定</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/*<!-------------------------人脸识别验证方式绑定tc01--------------------->*/}
                                <div className={stepTip === 6 ? "tc02" : "dn"}>
                                    <div className="tc_bg">
                                        <a className="close" onClick={() => this.setState({stepTip: 3})}>关闭</a>
                                        <div className="tc_cont pr">
                                            <div className="tc_title">人脸识别验证</div>
                                            {/*<div className="point2 pa"><p>保险箱密码错误！</p></div>*/}
                                            <div className="tc_cont_tex">
                                                <div className="tc_input clearfix">
                                                    <span>保险箱密码</span>
                                                    <input type="password" className="input-tex2"
                                                           placeholder="请输入保险箱密码" value={insurePwd}
                                                           onChange={e => this.setState({insurePwd: e.target.value})}/>
                                                </div>
                                                <a onClick={() => this.unBindPhoneFaceVerify()}
                                                   className="btn_kf m50">开始人脸识别验证</a>
                                            </div>
                                            <div className="Agreed clearfix">
                                                <div onClick={() => this.setState({isAgree: !isAgree})}
                                                     className={isAgree ? "choose on" : "choose agreed"}></div>
                                                <div className="choose_tex2"><span
                                                    className="textGrey9">我已阅读并同意</span>
                                                    <a href="https://wfw.fuyuncc.com/Compliance/tooldocument/use/100005_0_0_91.html"
                                                    className="textBlue">《人脸识别服务协议》</a>
                                                    <a href="https://wfw.fuyuncc.com/Compliance/tooldocument/use/100005_0_0_94.html"
                                                    className="textBlue">《个人信息共享授权书》</a></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/*<!-------------------------人脸识别验证方式绑定tc02--------------------->*/}
                                <div className={stepTip === 7 ? "tc02" : "dn"}>
                                    <div className="tc_bg">
                                        <a className="close" onClick={() => this.setState({stepTip: 3})}>关闭</a>
                                        <div className="tc_cont pr">
                                            <div className="tc_title">人脸识别验证</div>
                                            {this.state.certifyState === 'F' &&
                                                <div className="point2 pa">
                                                    <p>人脸验证失败，今天剩余{remainCount}次机会</p>
                                                </div>
                                            }
                                            <div className="tc_cont_tex">
                                                <div className="tc_input clearfix">
                                                    <span>保险箱密码</span>
                                                    <input type="password" className="input-tex2"
                                                           placeholder="请输入保险箱密码"
                                                           onChange={e => this.setState({insurePwd: e.target.value})}/>
                                                </div>
                                                <div className="tc_input clearfix">
                                                    <span>手机号</span>
                                                    <input type="text" className="input-tex2"
                                                           onChange={e => this.setState({phone: e.target.value})}
                                                           placeholder="请输入手机号码"/>
                                                </div>
                                                <div className="tc_input clearfix">
                                                    <span>验证码</span>
                                                    <input type="text" className="input-tex2"
                                                           onChange={e => this.setCode(e.target.value)}
                                                           placeholder="请输入验证码"/>
                                                    <input type="button" className="input-button-kefu"
                                                           onClick={() => this.bindPhoneSendMsg()} value={getCodeMsg}/>
                                                </div>
                                                <a onClick={this.submitChangePhone} className="btn_kf m50">确定</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </IonContent>
                {/*<!-------------------------灰色透明层--------------------->*/}
                {this.state.isFaceVerfy && <div className="greybackground"></div>}
                {this.state.isFaceVerfy &&
                    <div className="tc02">
                        <div className="tc_bg">
                            <div className="tip_tc">
                                <p>人脸识别验证中……</p>
                            </div>
                        </div>
                    </div>
                }
                <IonAlert
                    isOpen={this.state.isShowTip}
                    onDidDismiss={() => this.closeTipBox()}
                    header="温馨提示"
                    message={this.state.showTipMsg}
                    buttons={['OK']}
                />
            </IonPage>
        );
    }
}

export default withRouter(PhoneBind);
